import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ListDealerAction } from '../../redux/actions/DealerAction';
import Loader from '../layout/Loader';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Typography,
    Box,
} from '@mui/material';

const ListDealerForOrder = ({ nav }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchTerm, setSearchTerm] = useState('');

    const userLogin = useSelector((state) => state.userSignIn);
    const { userInfo } = userLogin;

    const list = useSelector((state) => state.listDealer);
    const { loading, success, dealer } = list;

    useEffect(() => {
        if (!userInfo) {
            navigate('/sign-in');
        }
    }, [userInfo, navigate]);

    useEffect(() => {
        dispatch(ListDealerAction(userInfo.token));
    }, [dispatch, userInfo.token]);

    const filteredDealers = dealer?.filter((d) =>
        d.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Box p={3}>
            <Typography variant="h5" mb={2} fontWeight="bold">
                All Dealers
            </Typography>
            <TextField
                variant="outlined"
                fullWidth
                placeholder="Search dealers by company name..."
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                sx={{ mb: 3 }}
            />
            {loading ? (
                <Loader />
            ) : (
                <TableContainer component={Paper} elevation={3}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong>Company</strong></TableCell>
                                <TableCell><strong>Name</strong></TableCell>
                                <TableCell><strong>Phone</strong></TableCell>
                                <TableCell><strong>Email</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDealers?.length > 0 ? (
                                filteredDealers.map((d) => (
                                    <TableRow key={d._id} hover>
                                        <TableCell>
                                            <Link to={`/schedule/view-dealer-orders/${d._id}`} style={{ textDecoration: 'none', color: '#1976d2' }}>
                                                {d.companyName}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{d.name}</TableCell>
                                        <TableCell>
                                            <a href={`tel:${d.phone}`} style={{ textDecoration: 'none', color: '#1976d2' }}>
                                                {d.phone}
                                            </a>
                                        </TableCell>
                                        <TableCell>{d.email}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        No dealers found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default ListDealerForOrder;
